import { render, staticRenderFns } from "./files-card.vue?vue&type=template&id=a0bb7792&"
import script from "./files-card.vue?vue&type=script&lang=js&"
export * from "./files-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports